var map = {
	"./Calculator.svg": 94564,
	"./Macbook.svg": 19613,
	"./Vector.svg": 91307,
	"./add-circle.svg": 20197,
	"./addprofile.svg": 97476,
	"./airplay.svg": 14598,
	"./app-icon-01.svg": 34064,
	"./app-icon-02.svg": 17293,
	"./app-icon-03.svg": 92010,
	"./app-icon-04.svg": 99197,
	"./app-icon-05.svg": 6138,
	"./app-icon-06.svg": 2777,
	"./app-icon-07.svg": 62797,
	"./app-icon-08.svg": 33001,
	"./app-icon-09.svg": 6800,
	"./app-icon-10.svg": 91286,
	"./apple-logo.svg": 7984,
	"./arrow-left.svg": 69023,
	"./audio.svg": 48983,
	"./bar.svg": 86128,
	"./bar1.svg": 1486,
	"./bell.svg": 47137,
	"./calendars.svg": 95091,
	"./cash-pay.svg": 99538,
	"./cash.svg": 18261,
	"./check-icon.svg": 19626,
	"./check.svg": 73028,
	"./chevron-down.svg": 29116,
	"./chevrons-left.svg": 7658,
	"./close-circle.png": 44174,
	"./close-circle.svg": 79097,
	"./close-circle1.svg": 56531,
	"./close-icon.svg": 12297,
	"./closes.svg": 5755,
	"./credit-card.svg": 43406,
	"./dash1.svg": 7572,
	"./dash2.svg": 73935,
	"./dash3.svg": 40725,
	"./dash4.svg": 54025,
	"./dash5.svg": 50080,
	"./dash6.svg": 59049,
	"./dash7.svg": 20181,
	"./dashboard.svg": 5662,
	"./datepicker.svg": 88404,
	"./debitcard.svg": 90383,
	"./delete-2.svg": 3596,
	"./delete.svg": 77054,
	"./delete1.svg": 59173,
	"./delete7.svg": 95453,
	"./dollar-square.svg": 58315,
	"./dollar.svg": 47029,
	"./download.svg": 3221,
	"./drag-drop.svg": 44420,
	"./dropdown.svg": 63038,
	"./edit-2.svg": 68955,
	"./edit-5.svg": 43372,
	"./edit-6.svg": 78088,
	"./edit-set.svg": 23322,
	"./edit.svg": 62365,
	"./ellipise.svg": 25017,
	"./ellipise1.svg": 18784,
	"./emoj-icon-01.svg": 72369,
	"./emoj-icon-02.svg": 53959,
	"./emoj-icon-03.svg": 56827,
	"./emoj-icon-04.svg": 45475,
	"./emoj-icon-05.svg": 23703,
	"./emoji-smile.svg": 32307,
	"./envelope.svg": 77137,
	"./excel.svg": 66074,
	"./expense.svg": 72902,
	"./expense1.svg": 58081,
	"./eye.svg": 9947,
	"./eye1.svg": 69173,
	"./facebook-logo.svg": 51125,
	"./facebook.png": 23852,
	"./fb-icon.svg": 78938,
	"./file-text-icon-01.svg": 65465,
	"./filter.svg": 73232,
	"./flag-01.svg": 66022,
	"./flag-02.svg": 17252,
	"./flag-03.svg": 67181,
	"./flag-04.svg": 23160,
	"./folder-minus.svg": 26928,
	"./folder.svg": 39055,
	"./fullscreen.svg": 73577,
	"./gear.svg": 2559,
	"./globe.svg": 11909,
	"./google-icon.svg": 17012,
	"./google.png": 34612,
	"./half-circle.svg": 1386,
	"./hand01.svg": 34946,
	"./heart.svg": 57583,
	"./hi.png": 49498,
	"./hi.svg": 18045,
	"./image.svg": 42703,
	"./language.png": 95153,
	"./life-buoy.svg": 70292,
	"./like.svg": 33747,
	"./linkedin-icon.svg": 25015,
	"./loader.svg": 94760,
	"./log-out.svg": 12586,
	"./magnifier.svg": 86890,
	"./mail.svg": 62711,
	"./maximize.svg": 37869,
	"./menu-icon-01.svg": 88981,
	"./menu-icon-02.svg": 97722,
	"./menu-icon-04.svg": 8540,
	"./menu-icon-05.svg": 26027,
	"./menu-icon-06.svg": 7225,
	"./menu-icon.svg": 12455,
	"./minus.svg": 68032,
	"./notification-bing.svg": 78865,
	"./pause.svg": 4315,
	"./pause1.svg": 4682,
	"./pay.svg": 85687,
	"./payment-icon-01.svg": 26546,
	"./payment-icon-02.svg": 59105,
	"./payment-icon-03.svg": 70766,
	"./payment-icon-04.svg": 43964,
	"./payment-icon-05.svg": 14518,
	"./payment-icon-06.svg": 32896,
	"./payment-icon-07.svg": 10697,
	"./payment-icon-08.svg": 72440,
	"./payment-icon-09.svg": 80452,
	"./payment-icon-10.svg": 80227,
	"./payment-icon-11.svg": 17703,
	"./payment-icon-12.svg": 52339,
	"./payment-icon-13.svg": 27648,
	"./payment-icon-14.svg": 65264,
	"./payment-icon-15.svg": 53206,
	"./payment-status.svg": 6541,
	"./pdf-02.svg": 64313,
	"./pdf.svg": 68370,
	"./places.svg": 60859,
	"./play-01.svg": 69054,
	"./plus-circle.svg": 95796,
	"./plus.svg": 94893,
	"./plus1.svg": 4866,
	"./plus11.svg": 10169,
	"./plus12.svg": 96945,
	"./power.svg": 18205,
	"./printer.svg": 42230,
	"./product.svg": 27881,
	"./pur-invoice.svg": 14388,
	"./purchase.svg": 11314,
	"./purchase1.svg": 76682,
	"./purchased-earnings.svg": 68359,
	"./qr-scan.svg": 20575,
	"./qrcode-scan.svg": 34540,
	"./quotation1.svg": 72286,
	"./razorpay.svg": 26953,
	"./return1.svg": 66947,
	"./reverse.svg": 88787,
	"./right-arrow.svg": 54652,
	"./sale.svg": 94703,
	"./sales.svg": 29053,
	"./sales1.svg": 6950,
	"./salesinvoice.svg": 97609,
	"./scan.svg": 73873,
	"./scanner.svg": 45987,
	"./scanner1.svg": 25134,
	"./scanners.svg": 88258,
	"./search-white.svg": 67919,
	"./search-whites.svg": 79233,
	"./search.svg": 77618,
	"./settings.svg": 55895,
	"./sidebar-delete-icon.svg": 22699,
	"./sidebar-icon-01.svg": 875,
	"./sidebar-icon-02.svg": 51715,
	"./sidebar-icon-03.svg": 85093,
	"./siderbar-icon1.svg": 83772,
	"./siderbar-icon2.svg": 89619,
	"./siderbar-icon3.svg": 39010,
	"./smile-chat.svg": 61320,
	"./sms-icon-01.svg": 24211,
	"./sms-icon-02.svg": 54777,
	"./sms-icon-03.svg": 62589,
	"./storage-icon-01.svg": 48576,
	"./storage-icon-02.svg": 99926,
	"./stripe.svg": 20178,
	"./sun-icon.svg": 98248,
	"./time-big.svg": 3747,
	"./time.svg": 73763,
	"./total-sales.svg": 457,
	"./transcation.svg": 34416,
	"./transfer1.svg": 9925,
	"./trash-bin.svg": 49617,
	"./trash.svg": 3996,
	"./trash12.svg": 86011,
	"./twitter-icon.svg": 65884,
	"./upload.svg": 68945,
	"./user-icon.svg": 49465,
	"./user.svg": 22676,
	"./users.svg": 70840,
	"./users1.svg": 89602,
	"./video.svg": 91165,
	"./voice.svg": 56164,
	"./wallet.svg": 86668,
	"./wallet1.svg": 2181,
	"./weekly-earning.svg": 61030,
	"./xls.svg": 79549,
	"./zip.svg": 93753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41199;